export const REQUEST = 'RECOVERY_PRICE_LIST_REQUEST';
export const GET_ALL_SUCCESS = 'RECOVERY_PRICE_LIST_GET_ALL_SUCCESS';
export const DELETE_SUCCESS = 'RECOVERY_PRICE_LIST_DELETE_SUCCESS';
export const GET_ALL_FAILURE = 'RECOVERY_PRICE_LIST_GET_ALL_FAILURE';
export const CLEAR_DATA = 'RECOVERY_PRICE_LIST_CLEAR_DATA';